import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { LogoFull } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <div className="section-sand min-h-[80vh] flex items-center justify-center py-16 px-4">
      <div className="bg-white rounded-3xl shadow-card border border-border p-8 sm:p-10 max-w-md w-full">
        <div className="flex justify-center mb-6"><LogoFull /></div>
        <h1 className="font-heading font-extrabold text-2xl text-ink text-center">Mot de passe oublié</h1>
        {sent ? (
          <div className="mt-6 text-center">
            <div className="w-16 h-16 rounded-full bg-emeraude/15 flex items-center justify-center mx-auto mb-4"><Mail className="w-8 h-8 text-emeraude" /></div>
            <p className="text-muted2 font-body">Si un compte existe pour <strong>{email}</strong>, un email avec un lien de réinitialisation (valable 1 heure) vient d'être envoyé.</p>
            <Link to="/login" className="inline-block mt-6 text-emeraude font-bold hover:underline" data-testid="back-login-link">Retour à la connexion</Link>
          </div>
        ) : (
          <>
            <p className="text-center text-sm text-muted2 font-body mt-3">Entrez votre email pour recevoir un lien de réinitialisation.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <Input data-testid="forgot-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl bg-sand" />
              <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full h-12 rounded-full bg-canard hover:bg-canard-dark font-bold">{loading ? "..." : "Envoyer le lien"}</Button>
            </form>
            <Link to="/login" className="flex items-center justify-center gap-1 mt-6 text-sm text-muted2 hover:text-canard font-semibold" data-testid="back-login-link"><ArrowLeft className="w-4 h-4" /> Retour à la connexion</Link>
          </>
        )}
      </div>
    </div>
  );
}
